import React from 'react';
import { Form, Icon, Input, Button, Checkbox, notification, Statistic } from 'antd';
import { omit } from 'ramda';
import md5 from 'md5';
import { useBoolean } from '../../../components/use';
import Context from '../../../components/layout/Container/Context';
import eventBus from '../../../components/layout/Container/EventBus';
import api from '../../../config/api';
import { network, strings, auth, asserts, generators } from '../../../utils';
import { secret } from '../../../utils/biz';
import { WebIM } from '../../../webImConfig';
import './form.less';

const SHOW_CAP_COUNT = 1;
const { Decrypt, Encrypt } = secret;
const { Countdown } = Statistic;

// mode 新增case，mode === 'modal' 为页面内弹窗登陆，此时需要额外做处理：1.忘记密码及注册要关闭弹窗2.登陆之后要刷新
export default Form.create()(({ form, history, mode }) => {
  const { getFieldDecorator, validateFields, getFieldsValue } = form;
  const {
    updatePrincipal,
    updateBasicConfig,
    updatePermission,
    updateMenus,
    updateDays,
    updateOrderType,
  } = React.useContext(Context);
  const [tid] = React.useState(strings.getGuId('').replace(/-/g, ''));
  const [counter, setCounter] = React.useState(0);
  const [error, setError] = React.useState('');
  const [isCheckAuth, setIsCheckAuth] = React.useState(false);
  const [mobile, setMobile] = React.useState('');
  const [smsCodeCounter, setSmsCodeCounter] = React.useState(false);
  const [smsCodeLoading, setSmsCodeLoading] = React.useState(false);
  const [stepData, setStepData] = React.useState({});

  const refreshCap = useBoolean(false);

  const [loading, setLoading] = React.useState(false);
  const loginName = localStorage.getItem('loginName');
  const userPwd = localStorage.getItem('userPwd') ? Decrypt(localStorage.getItem('userPwd')) : '';

  const linkRecipe = (e, url) => {
    e.preventDefault();
    mode === 'modal' && auth.closeAuthModal();
    history.push(url);
  };

  const submit = async (params) => {
    setLoading(true);
    setError('');
    try {
      const response = await network({
        url: api.core.login,
        method: 'form',
        params: {
          ...params,
          userPwd: md5(params.userPwd),
        },
        silence: true,
      });
      if (response.success) {
        localStorage.setItem('cid', response.data.cid);
        localStorage.setItem('login', 'true');
        localStorage.setItem('kgFromLoginFlag', 'true');
        localStorage.setItem('Authorization', response.data.token);
        Promise.all([
          updatePrincipal(),
          () => eventBus.emit(eventBus.type.UPDATE_CART_COUNT),
          updateBasicConfig(),
          updateMenus(),
          updateDays(),
          updateOrderType(),
          updatePermission(),
        ]);
        if (mode === 'modal') {
          auth.closeAuthModal();
          const { location } = history;
          if (location && location.pathname === '/webIm/contact/all') {
            localStorage.setItem('b2b_openWebIm', 'true');
            WebIM.login((res) => {
              if (res) {
                WebIM.init(Context);
              }
            });
          }
        } else {
          // const { record } = strings.fromQs();
          // !!record ? history.go(-1) : history.replace('/');

          const returnUrl = sessionStorage.getItem('loginReturnUrl');
          console.log('returnUrl:', returnUrl);

          if (returnUrl && returnUrl !== '/login') {
            sessionStorage.removeItem('loginReturnUrl');
            // 使用浏览器原生跳转，避免 React Router 的路径拼接问题
              window.location.replace(returnUrl);
            } else {
              history.replace('/');
            }
        }
        eventBus.emit(eventBus.type.FULL_LAYOUT_RELOAD);
      } else {
        const { checkResult, mobile } = response.data;
        if (checkResult === 4) {
          if (!asserts.isExist(mobile)) {
            setError('需要验证身份,请联系管理员维护手机号！');
          } else {
            setMobile(mobile);
            setIsCheckAuth(true);
            setStepData(params);
          }
        } else {
          setCounter((c) => c + 1);
          setError(response.data.message);
        }
      }
    } catch (error) {
      notification.error({
        message: '提示',
        description: error.message,
      });
    } finally {
      setLoading(false);
      refreshCap.toggle();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const params = await validateFields();
    const values = {
      ...params,
      ...stepData,
    };
    const rest = omit(['remember'], values);
    const { remember } = values;
    if (remember) {
      localStorage.setItem('loginName', values['loginName']);
      localStorage.setItem('userPwd', Encrypt(values['userPwd']));
    } else {
      localStorage.removeItem('loginName');
      localStorage.removeItem('userPwd');
    }
    submit({ ...rest, tid });
  };

  const memorizedImg = React.useMemo(
    () =>
      React.createElement('img', {
        key: refreshCap.value,
        title: '点击切换',
        alt: '验证码',
        src: `${process.env.SERVE}/captcha.jpg?tid=${tid}&t=${new Date().getTime()}`,
        onClick: refreshCap.toggle,
      }),
    [refreshCap.value, refreshCap.toggle, tid],
  );

  const CaptchaButton = () => (
    <>
      <Button
        disabled={smsCodeLoading || smsCodeCounter}
        loading={smsCodeLoading}
        onClick={fetchCapcha}
        style={{ marginLeft: '8px', height: '40px' }}
      >
        {smsCodeCounter ? (
          <Countdown
            format="重新发送(ss)秒"
            valueStyle={{ fontSize: 14 }}
            value={Date.now() + 1000 * 60}
            onFinish={() => {
              setSmsCodeCounter(false);
            }}
          />
        ) : (
          '获取验证码'
        )}
      </Button>
    </>
  );

  const fetchCapcha = async () => {
    setSmsCodeLoading(true);
    const loginNameValue = stepData.loginName || stepData.loginName || form.getFieldValue('loginName');
    if (!loginNameValue) {
      notification.error({
        message: '提示',
        description: '请输入账号',
      });
      setSmsCodeLoading(false);
      return;
    }
    const response = await network({
      method: 'get',
      url: `${api.core.smsVirifyCodeByLoginName}?loginName=${loginNameValue}`,
    });
    setSmsCodeLoading(false);
    if (response.success) {
      const result = generators.generatorObject(response.data);
      if (!result.success) {
        notification.error({
          message: '提示',
          description: result.message,
        });
        return;
      }
      console.log(response, 'response');
      setSmsCodeCounter(true);
    }
  };

  return (
    <Form className="login-form">
      {!isCheckAuth ? (
        <>
          <Form.Item>
            {getFieldDecorator('loginName', {
              rules: [{ required: true, message: '请输入用户名' }],
              initialValue: loginName ? loginName : '',
            })(
              <Input
                prefix={<Icon type="user" className="input-icon" />}
                size="large"
                placeholder="请输入用户名"
                onPressEnter={handleSubmit}
                name='loginName'
                autoComplete='username'
              />,
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('userPwd', {
              rules: [{ required: true, message: '请输入密码' }],
              initialValue: userPwd,
            })(
              <Input
                prefix={<Icon type="lock" className="input-icon" />}
                type="password"
                size="large"
                placeholder="请输入密码"
                onPressEnter={handleSubmit}
                name='password'
                autoComplete='current-password'
              />,
            )}
          </Form.Item>
          {counter >= SHOW_CAP_COUNT && (
            <Form.Item>
              {getFieldDecorator('rdmCode', {
                rules: [{ required: true, message: '请输入验证码' }],
              })(
                <Input
                  className="login-captcha"
                  // key={`${refreshCap.value}`} // 因为跨域问题，所以通过切key来重置img以拉取新的captcha
                  size="large"
                  placeholder="请输入验证码"
                  addonAfter={memorizedImg}
                  onPressEnter={handleSubmit}
                />,
              )}
            </Form.Item>
          )}
        </>
      ) : (
        <>
          <Form.Item>
            {getFieldDecorator('mobile', {
              rules: [{ required: true, message: '请输入手机号' }],
              initialValue: mobile ? mobile : '',
            })(
              <Input
                prefix={<Icon type="mobile" className="input-icon" />}
                size="large"
                placeholder="请输入手机号"
                disabled
              />,
            )}
          </Form.Item>
          <Form.Item>
            <div style={{ display: 'flex' }}>
              {getFieldDecorator('mobileCode', {
                rules: [
                  {
                    required: true,
                    message: '请输入手机验证码',
                  },
                ],
              })(
                <Input
                  prefix={<Icon type="safety" className="input-icon" />}
                  size="large"
                  // style={{ width: 180 }}
                  onPressEnter={handleSubmit}
                />,
              )}
              {<CaptchaButton />}
            </div>
          </Form.Item>
        </>
      )}
      <Form.Item>
        {!isCheckAuth ? (
          <>
            {getFieldDecorator('remember', {
              valuePropName: 'checked',
              initialValue: loginName ? true : false,
            })(<Checkbox>记住密码</Checkbox>)}
            <a
              className="float-right"
              href="/changePwd"
              onClick={(e) => linkRecipe(e, '/changePwd')}
            >
              忘记账号密码？
            </a>
          </>
        ) : null}
        <Form.Item>
          <Button
            loading={loading}
            type="primary"
            // htmlType="submit"
            size="large"
            className="x-fill-100 btn-info"
            onClick={handleSubmit}
          >
            登录
          </Button>
        </Form.Item>
        <div className="align-right">
          <a href="/register" onClick={(e) => linkRecipe(e, '/register')}>
            没有账号？去注册
          </a>
        </div>
      </Form.Item>
      <div className="form-error">{error}</div>
    </Form>
  );
});
